<template lang="pug">
el-dialog(v-dialog-drag, :width="width", top="50px", :title="title", :visible.sync="visible", :close-on-click-modal="false", @closed="$destroy()")
  .root
    el-table.jy-table(v-if="showTable", :data="checkList", height="100%", border)
      el-table-column(label="#", align="center", type="index", width="50px")
      el-table-column(label="名称", prop="fullName", show-overflow-tooltip)
      el-table-column(label="操作", align="center", width="60px")
        template(#default="{ row }")
          i.el-icon-delete(@click="delFolder(row)", style="font-size: 14px")
    el-tree(ref="tree", lazy, :load="treeLoad", :props="treeProps", node-key="folderId", highlight-current)
      template(#default="{ node, data }")
        label.tree-node
          el-checkbox.tree-btn(v-if="data.$check", :key="checkList.length", :value="idList", @input="setList(node)", :label="data.folderId") {{ undefined }}
          img.tree-icon(:src="data.$icon", alt="文件")
          .tree-ellipsis(:title="data.folderName") {{ data.folderName }}
  template(#footer)
    .footer
      .custom-slot
        component(:is="customSlots.footer")
      el-button(@click="visible = false", size="small") 取消
      el-button(type="primary", @click="confirm", size="small") 确定
</template>
<script>
import docService from "@/CommonDP/service/doc-service";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import { isFunction } from "lodash-es";
export default {
  name: "DocDialog",
  props: {
    queryRoot: {
      type: Function,
      async default() {
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId: this.prjId
        };
        const { data } = await docService.queryTree(params);
        return data;
      }
    },
    queryFolder: {
      type: Function,
      async default(node) {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId: this.prjId
        };
        const { data } = await docService.queryTree(params);
        return data;
      }
    },
    beforeSuccess: { type: Function, default: () => {} },
    customCheck: { type: [Function, undefined], default: undefined },
    check: { type: Function, default: (Vo) => Vo.isFolder === 0 },
    filter: { type: Function, default: (Vo) => Vo.folderId !== "recycle" },
    title: { type: String, default: "选择文件" },
    prjId: { type: String, default: "" },
    defaultList: { type: Array, default: () => [] }, // 已选择列表
    showTable: { type: Boolean, default: true },
    width: { type: String, default: () => "1024px" },
    multiple: { type: Boolean, default: true },
    customSlots: { type: Object, default: () => ({}) },
    isLeaf: { type: Function, default: (vo) => vo.childFlag === 0 }
  },
  data() {
    return {
      visible: false,
      checkList: [],
      folderId: "",
      treeProps: {
        label: "folderName",
        isLeaf: "leaf"
      }
    };
  },
  computed: {
    idList() {
      return this.checkList.map(({ folderId }) => folderId);
    }
  },
  created() {
    this.checkList = [...this.defaultList];
    this.openDialog();
  },
  methods: {
    async confirm() {
      const { checkList } = this;
      const beforeSuccess = this.beforeSuccess.bind(this);
      await beforeSuccess(checkList);
      this.resolve(checkList);
      this.visible = false;
    },
    async delFolder(row) {
      const index = this.checkList.findIndex(({ folderId }) => folderId === row.folderId);
      if (index > -1 && row.folderId) this.checkList.splice(index, 1);
    },
    addFolder(node) {
      if (this.checkList.some(({ folderId }) => node.key === folderId)) {
        return this.$message.warning("不得重复添加");
      }
      let anode = node;
      const names = [];
      const ids = [];
      while (anode?.key) {
        names.unshift(anode.label);
        ids.unshift(anode.data.folderId);
        anode = anode.parent;
      }
      if (!this.multiple) this.checkList = [];
      this.checkList.push({
        ...node.data,
        fullName: names.join("/"),
        fullIdPath: ids.join("/")
      });
    },
    async setList(node) {
      const { customCheck } = this;
      if (isFunction(customCheck)) {
        const res = await Reflect.apply(customCheck, this, [node]);
        if (res === false) return;
      }
      const isCheck = this.idList.find((id) => id === node.data.folderId);
      if (isCheck) this.delFolder(node.data);
      else this.addFolder(node);
    },
    // 打开窗口
    async openDialog() {
      this.visible = true;
    },
    // 进入文件夹
    async intoFolderById(folderId) {
      await this.$nextTick();
      // 为了异步触发方法 返回Promise
      return new Promise((resolve, reject) => {
        const tree = this.$refs.tree;
        const node = tree.getNode(folderId);
        // 调用Tree的加载 触发load
        try {
          node?.loadData(resolve);
        } catch (error) {
          reject();
        }
      });
    },
    // tree绑定加载方法
    async treeLoad(node, cb) {
      const isRoot = node.level === 0;
      const pid = isRoot ? "0" : node.key;
      const query = isRoot ? this.queryRoot : this.queryFolder;
      try {
        // 获取数据
        if (pid === "recycle") {
          cb([]);
        } else {
          const list = await query.call(this, node);
          const clist = [];
          const { filter, check, isLeaf } = this;
          for (const item of list) {
            if (filter.call(this, item)) clist.push(item);
            else continue;
            item.$check = check.call(this, item);
            item.leaf = isLeaf.call(this, item);
            item.$icon = tableRowIcon(item);
          }
          cb(clist);
          // 添加子元素
          if (isRoot) {
            // 根目录时 自动访问第一个文件夹
            const nextId = node.childNodes[0]?.key;
            if (nextId) {
              await this.intoFolderById(nextId);
              node.childNodes[0].expanded = true;
            }
          }
        }
      } catch (error) {
        cb([]);
      }
    }
  }
};
</script>
<style lang="scss" scoped src="./Doc.scss"></style>
